import { useTranslation } from "react-i18next";
import ContactButton from "../../atoms/buttons/ContactButton";
import { getMailToByCountry } from "../../../helpers/utils";

const ContactContent = ({ countryCode }) => {
  const { t } = useTranslation();
  const mailto = getMailToByCountry(countryCode);

  return (
    <>
      {countryCode !== "DE" ? (
        <div className="flex justify-center max-[640px]:mb-12 sm:px-0 sm:py-4  !pt-0">
          <ContactButton type="mail" href={mailto} />
          <ContactButton type="whatsapp" href="https://wa.me/908502224123" />
        </div>
      ) : (
        <>
          <div className="flex justify-center max-[640px]:mb-12 sm:px-0 sm:py-4 !pt-0 w-full">
            <ContactButton type="mail" href={mailto} />
          </div>
          <div className="flex justify-center">
            <a
              className="flex flex-row sm:leading-1 md:leading-2 items-center space-x-2 px-1 mx-1 font-small text-center font-league-light w-6/6 max-w-full underline"
              href={
                process.env.REACT_APP_GLOBAL_STORE_URL + "content/impressum"
              }
            >
              <span className="mx-auto text-center pt-2">
                {t("identity.impressum")}
              </span>
            </a>
          </div>
        </>
      )}
    </>
  );
};

export default ContactContent;
